import { getGridSizeName } from './gridSizeSelector';
import { isDebugEnabled } from '../../debug/debugUtil';

import { GRID_RESIZE, GRID } from './gridConstants';

export const setGridSize = (gridSize, sizeName) => ({ type: GRID_RESIZE, gridSize, sizeName });

const getSmallerGridSize = (sizeName) => {
    switch (sizeName) {
        case GRID.LARGE.name:
            return GRID.MEDIUM;
        case GRID.MEDIUM.name:
            return GRID.SMALL;
        case GRID.SMALL.name:
        case GRID.MOBILE.name:
        default:
            // only allow developers to access the mobile app size via keyboard shortcut
            return isDebugEnabled() ? GRID.MOBILE : GRID.SMALL;
    }
};

const getLargerGridSize = (sizeName) => {
    switch (sizeName) {
        case GRID.MOBILE.name:
            return GRID.SMALL;
        case GRID.SMALL.name:
            return GRID.MEDIUM;
        case GRID.MEDIUM.name:
        case GRID.LARGE.name:
        default:
            return GRID.LARGE;
    }
};

export const decreaseGridSize = () => (dispatch, getState) => {
    const { size, name } = getSmallerGridSize(getGridSizeName(getState()));
    dispatch(setGridSize(size, name));
};

export const increaseGridSize = () => (dispatch, getState) => {
    const { size, name } = getLargerGridSize(getGridSizeName(getState()));
    dispatch(setGridSize(size, name));
};
